export const LocalStorage = {
  UNIQUE_QUESTION_TOKEN: "unique-question-token",
  UNIQUE_ORGANIZATION_TOKEN: "unique-organization-token",
  CHAT_FLOAT_STORAGE_KEY: "chat-float-history",
  INPUT_MODAL_STORAGE_KEY: "input-modal-history",
};
